// Product fields shared by the Create Product wizard (ProductFormPage) and
// Create Related Listing.

export interface ProductContactOption {
  key: string;
  value: string;
  text: string;
}

export const PRODUCT_CONTACT_OPTIONS: ProductContactOption[] = [
  {
    key: "Patrick Klotzbach",
    value: "Patrick Klotzbach",
    text: "Patrick Klotzbach",
  },
  { key: "Robyn Baun", value: "Robyn Baun", text: "Robyn Baun" },
  { key: "Jonathan Briggs", value: "Jonathan Briggs", text: "Jonathan Briggs" },
  { key: "Alex Burns", value: "Alex Burns", text: "Alex Burns" },
  { key: "Kayla Winter", value: "Kayla Winter", text: "Kayla Winter" },
  {
    key: "Marissa Carbonell",
    value: "Marissa Carbonell",
    text: "Marissa Carbonell",
  },
];

/** The contact options plus any of `extra` that aren't among them (e.g. a
 *  prefilled contact who has left, or the logged-in user), so a Select can
 *  show and offer them. */
export function productContactOptionsWith(
  ...extra: (string | null | undefined)[]
): ProductContactOption[] {
  let options = PRODUCT_CONTACT_OPTIONS;
  for (const name of extra) {
    const value = name?.trim();
    if (value && !options.some((o) => o.value === value)) {
      options = [...options, { key: value, value, text: value }];
    }
  }
  return options;
}

// Same limits as ProductFormPage's Yup schema.
export const PRODUCT_TITLE_MIN_LENGTH = 8;
export const PRODUCT_TITLE_MAX_LENGTH = 250;

export function validateProductTitle(title: string): string | null {
  const trimmed = title.trim();
  if (!trimmed) return "Product Title is required";
  if (trimmed.length < PRODUCT_TITLE_MIN_LENGTH) {
    return `Product Title must be at least ${PRODUCT_TITLE_MIN_LENGTH} characters`;
  }
  if (trimmed.length > PRODUCT_TITLE_MAX_LENGTH) {
    return `Product Title must be at most ${PRODUCT_TITLE_MAX_LENGTH} characters`;
  }
  return null;
}
